type PendingNavigation = {
  module: string;
  fromScreen: string;
  toScreen: string;
  startedAt: number;
};

const STORAGE_KEY = "pcs_pending_navigation";

export function startScreenNavigation(module: string, fromScreen: string, toScreen: string) {
  const payload: PendingNavigation = {
    module,
    fromScreen,
    toScreen,
    startedAt: performance.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function getPendingScreenNavigation(): PendingNavigation | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as PendingNavigation;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingScreenNavigation() {
  sessionStorage.removeItem(STORAGE_KEY);
}
